import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const ShowCode = () => {
  const navigate = useNavigate();
  const onGoToWaitingRoom = () => {
    navigate("/fun_learning/waitingRoomCaptain");
  };
  return (
    <div className="h-screen dark:bg-gray-700 bg-gray-200 pt-12 pb-5 ">
      <div className="mt-10 container bg-gradient-to-r from-indigo-500 to-violet-500 dark:from-blue-800 dark:to-pink-500 text-white p-8 rounded-lg shadow-lg max-w-md mx-auto">
        <div className="text-3xl font-bold mb-4">Your Code</div>
        <div className="text-lg mb-4">
          <span className="text-yellow-400 font-bold">
            Show your code to fellows!
          </span>
          <div className="text-center text-6xl mt-5">🏆</div>
        </div>
        <div className="bg-white dark:bg-gray-800 text-gray-800 dark:text-white rounded-lg px-4 py-2 flex items-center justify-between">
          <span className="text-5xl font-semibold">1278</span>
        </div>
        <div className="relative inline-flex group mt-10">
          <div className="absolute transitiona-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200 animate-tilt"></div>
          <button
            onClick={onGoToWaitingRoom}
            className="relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-gray-700 dark:bg-gray-900 font-pj rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
          >
            대기방으로 가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShowCode;
